module.exports = __webpack_public_path__ + "assets/mp3/audio3/audio_3_0.mp3";